/**
 * @generated SignedSource<<a071d99af39319ded2359d392b6fad15>>
 * @relayHash 0d0df79e6a13fea3f48188eca1c96c3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 26797fdc37901e5b03c1a428ce7a0bc01e38ab7eed86b58300a1a01d78636cff

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "26797fdc37901e5b03c1a428ce7a0bc01e38ab7eed86b58300a1a01d78636cff",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
